import React, { memo } from "react";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { GroupBookingLogsTypes } from "app/routes/Activity/ActivityBookingLogs/indexModel";
import { BookingLogsModel } from "app/models";
import { Loading } from "app/components/Wrappers";
import BookingLogGroup from "./BookingLogGroup";
import NoBookingLogs from "../NoResults/NoBookingLogs";

interface Props {
  bookingLogsContainer: any;
  data: GroupBookingLogsTypes;
  nullData: boolean;
  loading: boolean;
  isCoach: boolean;
}

enum TimeRangeEnum {
  Today = "today",
  ThisWeek = "thisWeek",
  ThisMonth = "thisMonth",
  EverythingElse = "everythingElse",
}

const BookingLogList = ({
  data,
  nullData,
  loading,
  isCoach,
  bookingLogsContainer,
}: Props): React.ReactElement => {
  const { t } = useTranslation();

  if (nullData && !loading) {
    return (
      <NoBookingLogs />
    );
  }

  if (!data && !loading) {
    return null;
  }

  return (
    <div className={styles.content_container}>
      {Object.entries(data).map(([key, logs]: [TimeRangeEnum, BookingLogsModel[]]) => (
        <BookingLogGroup
          key={key}
          groupKey={key}
          logs={logs}
          isCoach={isCoach}
          t={t}
        />
      ))}
      {loading && (
        <div className={styles.loading_container}>
          <Loading loadType="spinner" isLoading={loading} />
        </div>
      )}
      <div className={styles.container_ref} ref={bookingLogsContainer} />
    </div>
  );
};

export default memo(BookingLogList);
